import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import { useGroupSubscriptionConfirm, useTeamSubscriptionsCreate } from '../../../../hooks';
import { GROUP_SUBSCRIPTION_TEAM } from '../../../../src/constants';
import { Button, Divider } from '../../../BaseUI';
import { TokenizeTextField } from '../../../FormFields';
import subscriptionEmailsValidation from '../../subscriptionEmailsValidation';
import styles from './styles.module.scss';

const validationSchema = () =>
  Yup.object().shape({
    emails: subscriptionEmailsValidation(),
  });

export default function AddTeamMembers() {
  const { addTeamSubscriptionsAsync } = useTeamSubscriptionsCreate();
  const onSubmit = async (values, actions) => {
    const resp = await addTeamSubscriptionsAsync(values.emails.map((email) => email.value));
    if (resp?.success) {
      actions.resetForm();
    }
  };
  const { mutateAsync: confirmGroupSubscription } = useGroupSubscriptionConfirm();
  const [totalCost, setTotalCost] = useState(0);
  const [totalEligibleSub, setTotalEligibleSubs] = useState(0);

  const prepareConfirmation = async ({
    emails,
  }: {
    emails: [{ label: string; value: string }];
  }) => {
    const teamData = await confirmGroupSubscription({
      emails: emails.map((email) => email.value),
      group_subscription_type: GROUP_SUBSCRIPTION_TEAM,
    });
    setTotalCost(teamData.totalPrice);
    setTotalEligibleSubs(teamData.totalEligibleSubs);
  };

  return (
    <Formik onSubmit={onSubmit} initialValues={{ emails: [] }} validationSchema={validationSchema}>
      {({ isSubmitting, isValid, dirty, values }) => (
        <Form>
          <TokenizeTextField
            name="emails"
            label="Manually add team members"
            placeholder="Enter emails"
            onChangeCallBack={() => prepareConfirmation(values)}
          />
          <span className={styles.tokenizeHint}>
            Add people by email separating each address by a comma.
          </span>

          {totalEligibleSub > 0 && isValid && dirty && (
            <>
              <Divider marginY="medium" />
              <div className={styles.totalContainer}>
                <div>Accounts total: {totalEligibleSub}</div>
                <div>${totalCost / 100}.00</div>
              </div>
              <Divider marginY="medium" />
            </>
          )}
          <Button
            variant="primary"
            className="mt2"
            type="submit"
            disabled={(!isValid && dirty) || isSubmitting}
          >
            Purchase
          </Button>
        </Form>
      )}
    </Formik>
  );
}
